import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  LogoutOutlined,
  SnippetsOutlined,
  InboxOutlined,
  DatabaseOutlined,
  DeliveredProcedureOutlined,
  QrcodeOutlined,
  UnorderedListOutlined,
  MenuOutlined,
  CloseOutlined,
  FileImageOutlined,
  CoffeeOutlined,
  AppstoreAddOutlined,
} from "@ant-design/icons";
import {
  Badge,
  Button,
  Drawer,
  Image,
  Layout,
  Menu,
  Modal,
  theme,
  Tooltip,
  Typography,
} from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CustomerOrderInfo, SubscriptionInfo, UserInfo } from "../../context";
import "./layout.css";
import AccountDetails from "../merchant/account/AccountDetails";
import LOGO from "./../../assets/tinyimg/logo.webp";

const { Header, Sider, Content, Footer } = Layout;

const MerchantLayout = ({ children }) => {
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const [collapsed, setCollapsed] = useState(
    window.innerWidth > 635 ? false : true
  );
  const navtab =
    window.location.pathname === "/"
      ? "1"
      : window.location.pathname === "/products"
      ? "2"
      : // : window.location.pathname === "/inventory"
      // ? "3"
      window.location.pathname === "/delivery"
      ? "4"
      : window.location.pathname === "/qr-code"
      ? "5"
      : window.location.pathname === "/report"
      ? "6"
      : window.location.pathname === "/employee"
      ? "7"
      : window.location.pathname === "/subscription"
      ? "8"
      : window.location.pathname === "/banner"
      ? "9"
      : window.location.pathname === "/additional-services"
      ? "10"
      : window.location.pathname === "/order-pay-later"
      ? "11"
      : // : window.location.pathname === "/dine-setup"
        // ? "11"
        "";
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const themeStyle = "dark";
  const [current, setCurrent] = useState("1");
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { handleLogoutTkn, userData } = useContext(UserInfo);
  const { merchantOrderSaveList, additionalService } =
    useContext(CustomerOrderInfo);
  const [accountDetailsDrawer, setAccountDetailsDrawer] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);

  function getItem(label, key, icon, children, disabled, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
      disabled,
    };
  }

  const items = [
    getItem(
      <Link to="/" relative="path">
        <Badge
          count={merchantOrderSaveList.data.length}
          size="small"
          style={{ marginRight: -50, marginTop: 10 }}
        >
          <Typography style={{ color: navtab === "1" ? "#fff" : "#aeaeae" }}>
            Orders
          </Typography>
        </Badge>
      </Link>,
      "1",
      !openDrawer && collapsed ? (
        <Badge
          count={merchantOrderSaveList.data.length}
          size="small"
          style={{ marginRight: -10, marginTop: 10 }}
        >
          <SnippetsOutlined />
        </Badge>
      ) : (
        <SnippetsOutlined />
      )
    ),
    userData.data.usersmerpermission.find(
      ({ permission }) => permission === "allow-dine-paylater"
    )
      ? getItem(
          <Link to="/order-pay-later" relative="path">
            Pay Later Order
          </Link>,
          "11",
          <FileImageOutlined />
        )
      : null,
    getItem(
      <Link to="/products" relative="path">
        Products
      </Link>,
      "2",
      <InboxOutlined />
    ),
    // getItem(
    //   !Boolean(
    //     parseInt(
    //       subscriptionDetails.data.subsmerchantfeat.enable_inventory_report
    //     )
    //   ) ? (
    //     <Typography style={{ color: "inherit" }}>Inventory</Typography>
    //   ) : (
    //     <Link to="/inventory" relative="path">
    //       Inventory
    //     </Link>
    //   ),
    //   "3",
    //   <DatabaseOutlined />,
    //   "",
    //   !Boolean(
    //     parseInt(
    //       subscriptionDetails.data.subsmerchantfeat.enable_inventory_report
    //     )
    //   )
    // ),
    getItem(
      !Boolean(
        parseInt(
          subscriptionDetails.data.subsmerchantfeat.enable_inventory_report
        )
      ) ? (
        <Typography style={{ color: "inherit" }}>Delivery</Typography>
      ) : (
        <Link to="/delivery" relative="path">
          Delivery
        </Link>
      ),
      "4",
      <DeliveredProcedureOutlined />,
      "",
      !Boolean(
        parseInt(
          subscriptionDetails.data.subsmerchantfeat.enable_inventory_report
        )
      )
    ),
    getItem(
      <Link to="/qr-code" relative="path">
        QR Code & Links
      </Link>,
      "5",
      <QrcodeOutlined />
    ),
    getItem(
      !Boolean(
        parseInt(subscriptionDetails.data.subsmerchantfeat.enable_sales_report)
      ) ? (
        <Typography style={{ color: "inherit" }}>Report</Typography>
      ) : (
        <Link to="/report" relative="path">
          Report
        </Link>
      ),
      "6",
      <UnorderedListOutlined />,
      "",
      !Boolean(
        parseInt(subscriptionDetails.data.subsmerchantfeat.enable_sales_report)
      )
    ),
    getItem(
      <Link to="/employee" relative="path">
        Employee
      </Link>,
      "7",
      <UnorderedListOutlined />
    ),
    getItem(
      <Link to="/subscription" relative="path">
        Subscription
      </Link>,
      "8",
      <UserOutlined />
    ),
    userData.data.usersmerpermission.find(
      ({ permission }) => permission === "allow-banner"
    )
      ? getItem(
          <Link to="/banner" relative="path">
            Banner
          </Link>,
          "9",
          <FileImageOutlined />
        )
      : null,
    userData.data.usersmerpermission.find(
      ({ permission }) => permission === "allow-additional-services"
    )
      ? getItem(
          <Link to="/additional-services" relative="path">
            <Badge
              count={additionalService.data.length}
              size="small"
              style={{ marginRight: -9, marginTop: 10 }}
            >
              <Typography
                style={{ color: navtab === "10" ? "#fff" : "#aeaeae" }}
              >
                Additional Service
              </Typography>
            </Badge>
          </Link>,

          // <Link to="/additional-services" relative="path">
          //   Addtional Services
          // </Link>,
          "10",
          // <AppstoreAddOutlined />
          !openDrawer && collapsed ? (
            <Badge
              count={additionalService.data.length}
              size="small"
              style={{ marginRight: -10, marginTop: 10 }}
            >
              <AppstoreAddOutlined />
            </Badge>
          ) : (
            <AppstoreAddOutlined />
          )
        )
      : null,

    // userData.data.usersmerpermission.find(
    //   ({ permission }) => permission === "allow-dine-setup"
    // )
    //   ? getItem(
    //       <Link to="/dine-setup" relative="path">
    //         Dine Setup
    //       </Link>,
    //       "11",
    //       <CoffeeOutlined />
    //     )
    //   : null,
  ];

  const MenuonClick = (e) => {
    setCurrent(e.key);
  };

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setOpen(false);
      setConfirmLoading(false);
      handleLogoutTkn();
    }, 2000);
  };

  useEffect(() => {}, [current]);

  return (
    <Layout
      style={{ minHeight: "100vh" }}
      hasSider={window.innerWidth > 500 ? true : false}
    >
      {window.innerWidth > 500 && (
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          style={{
            overflow: "auto",
            height: "100vh",
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,
            background: themeStyle === "dark" ? "#001529" : "#fff",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                height: collapsed ? 45 : 100,
                width: collapsed ? 45 : 100,
                margin: 16,
                background: themeStyle === "dark" ? "transparent" : "#001529",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Image
                width={"auto"}
                height={collapsed ? 45 : 100}
                src={
                  userData.data.usersmerinfo.business_logo !== null
                    ? `${import.meta.env.VITE_API_IMAGE}logo/${
                        userData.data.usersmerinfo.business_logo
                      }`
                    : LOGO
                }
                placeholder={"logo"}
                preview={false}
                alt="logo"
              />
            </div>
          </div>

          <Menu
            onClick={MenuonClick}
            defaultSelectedKeys={[navtab]}
            mode="inline"
            theme={themeStyle}
            items={items}
          />
        </Sider>
      )}

      <Layout
        className="container3"
        style={{
          marginLeft: window.innerWidth > 500 ? (collapsed ? 80 : 200) : 0,
        }}
      >
        <Header
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        >
          <div style={{ display: "flex" }}>
            <div style={{ flexGrow: 1 }}>
              {window.innerWidth > 500 ? (
                collapsed ? (
                  <MenuUnfoldOutlined
                    style={{ marginLeft: 10, fontSize: 15 }}
                    className="trigger"
                    onClick={() => setCollapsed(!collapsed)}
                  />
                ) : (
                  <MenuFoldOutlined
                    style={{ marginLeft: 10, fontSize: 15 }}
                    className="trigger"
                    onClick={() => setCollapsed(!collapsed)}
                  />
                )
              ) : (
                <MenuOutlined
                  style={{ marginLeft: 10, fontSize: 15 }}
                  className="trigger"
                  onClick={() => setOpenDrawer(!openDrawer)}
                />
              )}
            </div>
            <div style={{ marginRight: 20 }}>
              <Tooltip
                placement="bottomRight"
                title={"Account"}
                color={"#2db7f5"}
              >
                <UserOutlined
                  style={{ marginRight: 15, fontSize: 15 }}
                  className="trigger"
                  onClick={() => {
                    setAccountDetailsDrawer(true);
                  }}
                />
              </Tooltip>
              <Tooltip
                placement="bottomRight"
                title={"Logout"}
                color={"#2db7f5"}
              >
                <LogoutOutlined
                  style={{ fontSize: 15 }}
                  className="trigger"
                  onClick={() => setOpen(true)}
                />
              </Tooltip>
            </div>
          </div>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            // height: "100%",
            background: colorBgContainer,
            overflow: "initial",
          }}
        >
          {children}
        </Content>
        <Footer
          style={{
            textAlign: "center",
            fontWeight: "bold",
            width: "100%",
            position: "inherit",
            marginBottom: 0,
          }}
        >
          DigiMenu ©2023 Created by Nehemiah Solutions
        </Footer>
      </Layout>

      <Drawer
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
        placement="left"
        closable={false}
        bodyStyle={{ backgroundColor: "#001529" }}
        width={220}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div style={{ flexGrow: 1 }}></div>
          <div>
            <Tooltip title="Close">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setOpenDrawer(false);
                }}
                style={{ color: "#fff", backgroundColor: "#001529" }}
                icon={<CloseOutlined />}
              />
            </Tooltip>
          </div>
        </div>
        {/* <Menu
          onClick={MenuonClick}
          defaultSelectedKeys={[navtab]}
          theme={themeStyle}
          items={items}
          mode="inline"
        /> */}
        <Menu
          onClick={MenuonClick}
          defaultSelectedKeys={[navtab]}
          mode="inline"
          theme={themeStyle}
          items={items}
        />
      </Drawer>

      <Modal
        title="Are you sure to logout?"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setOpen(false)}
        centered
        width={350}
      />

      {accountDetailsDrawer && (
        <AccountDetails
          open={accountDetailsDrawer}
          close={() => setAccountDetailsDrawer(false)}
        />
      )}
    </Layout>
  );
};
export default MerchantLayout;
